/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ImportDataValidatonError,
    ImportDataValidatonErrorFromJSON,
    ImportDataValidatonErrorFromJSONTyped,
    ImportDataValidatonErrorToJSON,
} from './';

/**
 * 
 * @export
 * @interface ImportDataResponse
 */
export interface ImportDataResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ImportDataResponse
     */
    hasErrors?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ImportDataResponse
     */
    waterMark?: number;
    /**
     * 
     * @type {Array<ImportDataValidatonError>}
     * @memberof ImportDataResponse
     */
    errors?: Array<ImportDataValidatonError> | null;
}

export function ImportDataResponseFromJSON(json: any): ImportDataResponse {
    return ImportDataResponseFromJSONTyped(json, false);
}

export function ImportDataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportDataResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hasErrors': !exists(json, 'hasErrors') ? undefined : json['hasErrors'],
        'waterMark': !exists(json, 'waterMark') ? undefined : json['waterMark'],
        'errors': !exists(json, 'errors') ? undefined : (json['errors'] === null ? null : (json['errors'] as Array<any>).map(ImportDataValidatonErrorFromJSON)),
    };
}

export function ImportDataResponseToJSON(value?: ImportDataResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'hasErrors': value.hasErrors,
        'waterMark': value.waterMark,
        'errors': value.errors === undefined ? undefined : (value.errors === null ? null : (value.errors as Array<any>).map(ImportDataValidatonErrorToJSON)),
    };
}


